import { ShopServiceEffects } from '@app/shop/store/effects/shopService.effects'
import { ShopShopOrderEffects } from '.'

export const effects: any[] = [ShopServiceEffects, ShopShopOrderEffects]

export * from '@app/shop/store/effects/shopService.effects'
export * from '@app/shop/store/effects/shopOrder.effects'
